import './index.scss';
import { defineComponent, h } from 'vue';
import { Modal } from '@phi/components';
import { FormTextSubmit } from '@components/form/form-text-submit';
import { StoredViewport } from '@features/save-viewpoint/stored-viewport';
import {
    find_camera_target_point_from_normalized_2d_screen_coordinates,
    get_camera_look_vector,
} from '@frontend/utility';
import { Vector2 } from 'three';
import {
    hide_viewport_manager,
    remove_a_viewport,
    show_viewport_manager,
    showing_viewport_manager,
    stored_viewports,
} from '@features/save-viewpoint/state';
import DismissibleButton from '@components/dismissible-button';
import { move_to_viewport } from '@frontend/scene';
import { Flex } from '@phi/components/layout';

export const ViewPortManager = defineComponent({
    methods: {
        store_new_viewport(name: string) {
            const stored_viewport = new StoredViewport(
                uid_camera.left,
                uid_camera.right,
                uid_camera.top,
                uid_camera.bottom,
                viewSize,
                uid_camera.position,
                uid_camera.up,
                get_camera_look_vector(uid_camera),
                find_camera_target_point_from_normalized_2d_screen_coordinates(uid_camera, new Vector2(0, 0)),
                name,
            );
            stored_viewports.push(stored_viewport);
        },

        retrieve(x: StoredViewport) {
            move_to_viewport(x);
            hide_viewport_manager();
        },

        delete(x: StoredViewport) {
            remove_a_viewport(x);
        },
    },

    render() {
        return h(Modal, {
            show: showing_viewport_manager.value,
            'onUpdate:show': x => {
                if (x) show_viewport_manager();
                else hide_viewport_manager();
            },
            id: 'storeRetrieveViewportModal',
            title: 'Save/recall viewport',
            width: 'narrower',
        }, {
            body: () => [
                h('section', [
                    h('p', 'Select a stored viewport:'),
                    h(Flex, {
                        direction: 'row',
                        gap: 'tight',
                        wrap: true,
                    }, () => stored_viewports.map((x, i) =>
                        h(DismissibleButton, {
                            key: i,
                            label: x.name,
                            onClick: () => this.retrieve(x),
                            onDismiss: () => this.delete(x),
                        }),
                    )),
                ]),
                h('hr'),
                h(FormTextSubmit, { onSubmit: this.store_new_viewport }),
            ],
            footer: () => h('button', {
                type: 'button',
                class: 'btn',
                onClick: hide_viewport_manager,
            }, 'Close'),
        });
    }
});
